import type {Result, UseCase} from 'framework';
import type {ExerciseId} from '../../domain/exercise-id.value-object';
import type {WorkoutError} from '../../domain/errors';
import type {ExerciseCatalogRepository} from '../ports/exercise-catalog.repository';

export class DeleteCustomExercise implements UseCase<[ExerciseId], void> {
  constructor(private readonly repository: ExerciseCatalogRepository) {}

  execute(id: ExerciseId): Promise<Result<void, WorkoutError>> {
    return this.repository.deleteCustom(id);
  }
}
